import { Directive, Input, OnChanges, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserAuthorities } from '../../modules/agri-auth/constants/user-authorities.const';
import { User } from '../../modules/agri-auth/models/user.model';
import { SessionQuery } from '../../modules/agri-auth/state/session';

@Directive({
  selector: '[appHasRole]'
})
export class HasRoleDirective implements OnInit, OnChanges, OnDestroy {
  private _subscription: Subscription;
  private _user: User;
  private _currentVisible: boolean;
  @Input('appHasRole') roles: UserAuthorities | UserAuthorities[];
  @Input('appHasRoleMatchAll') matchAll: boolean;
  @Input('appHasRoleInverted') inverted: boolean;

  constructor(
    private _container: ViewContainerRef,
    private _template: TemplateRef<any>,
    private _sessionQuery: SessionQuery) {
  }

  ngOnInit() {
    this._subscription = this._sessionQuery.user$.subscribe((user: User) => {
      this._user = user;
      this._checkContentVisibility();
    });
  }

  ngOnChanges() {
    this._checkContentVisibility();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  private _checkContentVisibility() {
    let contentVisible: boolean;
    const authorities = this._user && this._user.authorities || [];
    if (!Array.isArray(this.roles)) {
      contentVisible = authorities.includes(this.roles);
    } else if (this.matchAll && Array.isArray(this.roles)) {
      contentVisible = this.roles.every(role => authorities.includes(role));
    } else {
      contentVisible = authorities.some(authority => {
        return Array.isArray(this.roles) ? this.roles.includes(authority) : authority === this.roles;
      });
    }

    contentVisible = this.inverted ? !contentVisible : contentVisible;

    if (!contentVisible && this._currentVisible) {
      this._container.clear();
    } else if (contentVisible && !this._currentVisible) {
      this._container.createEmbeddedView(this._template);
    }

    this._currentVisible = contentVisible;
  }
}
